{
  "next": "Próximo",
  "previous": "Anterior"
}
